import {
  TransportConfigurationWebDto,
  TransportVariantDto,
} from '@/features/dashboard/tourTransport/types/TransportConfigurationDto.ts';
import {
  TransportFormData,
  TransportInputForm,
} from '@/features/dashboard/tourTransport/schemas/transportSchema.ts';
import { TransportOffering } from '@/features/dashboard/tourTransport/types/TransportOffering.ts';
import { ParticipantLimitMode } from '@/features/dashboard/tourTransport/types/ParticipantLimitMode.ts';

const isFlatVariant = (variant: TransportVariantDto): boolean =>
  variant.prices.length === 1 && variant.prices[0].ageRange == null;

export const transportConfigurationMapper = {
  fromDtoToForm(dto: TransportConfigurationWebDto): TransportInputForm {
    if (dto.transportOffering === TransportOffering.NO_TRANSPORT) {
      return {
        transportOffering: TransportOffering.NO_TRANSPORT,
        selectionMode: null,
        variants: [],
      };
    }

    return {
      transportOffering: TransportOffering.OFFERS_TRANSPORT,
      selectionMode: dto.selectionMode,
      variants: dto.variants.map((variant) => {
        const flat = isFlatVariant(variant);
        return {
          id: variant.id,
          name: variant.name,
          description: variant.description ?? '',
          participantLimitMode:
            variant.participantLimit != null
              ? ParticipantLimitMode.LIMITED
              : ParticipantLimitMode.UNLIMITED,
          participantLimit: variant.participantLimit ?? undefined,
          currency: variant.currency,
          isPriceByAge: !flat,
          flatPrice: flat ? variant.prices[0].amount : undefined,
          ageRangePrices: flat
            ? []
            : variant.prices.map((price) => ({
                minAge: price.ageRange?.minAge,
                maxAge: price.ageRange?.maxAge,
                amount: price.amount,
              })),
        };
      }),
    };
  },

  fromFormToDto(form: TransportFormData): TransportConfigurationWebDto {
    if (form.transportOffering === TransportOffering.NO_TRANSPORT) {
      return {
        transportOffering: TransportOffering.NO_TRANSPORT,
        selectionMode: null,
        variants: [],
      };
    }

    return {
      transportOffering: TransportOffering.OFFERS_TRANSPORT,
      selectionMode: form.selectionMode ?? null,
      variants: form.variants.map((variant) => ({
        ...(variant.id ? { id: variant.id } : {}),
        name: variant.name,
        description: variant.description?.trim() ? variant.description : null,
        participantLimit:
          variant.participantLimitMode === ParticipantLimitMode.LIMITED
            ? (variant.participantLimit ?? null)
            : null,
        currency: variant.currency,
        prices: variant.isPriceByAge
          ? variant.ageRangePrices.map((price) => ({
              amount: price.amount,
              ageRange: {
                minAge: price.minAge as number,
                maxAge: price.maxAge as number,
              },
            }))
          : [{ amount: variant.flatPrice as number, ageRange: null }],
      })),
    };
  },
};
